import { render, staticRenderFns } from "./InspectionRequest.vue?vue&type=template&id=65251b26"
import script from "./InspectionRequest.vue?vue&type=script&lang=js"
export * from "./InspectionRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports